// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        getUserHistory: builder.query({
            query: () =>({ url: `/fetchUserdata`, headers: { Authorization: `Bearer ${ localStorage.getItem("token")}`  }})
        }),
        deleteUserHistory: builder.query({
            query: (docId) => ({ 
                url: `/delete_document/${docId}`, 
                method: 'DELETE', 
                headers: { Authorization: `Bearer ${ localStorage.getItem("token")}`  } 
            })
        }),
        getUserHistoryData: builder.query({
            query: (docId) => ({ 
                url: `/get_user_documents/${docId}`, 
                headers: { Authorization: `Bearer ${ localStorage.getItem("token")}`  } 
            })
        }),
    })
})

export const { 
    useGetUserHistoryQuery, 
    useLazyDeleteUserHistoryQuery, 
    useLazyGetUserHistoryQuery,
    useGetUserHistoryDataQuery,
    useLazyGetUserHistoryDataQuery
} = dashboardApi;